import Vue from 'vue'
import App from './App.vue'
import Rollbar from 'vue-rollbar'
import i18n from './i18n'

Vue.config.productionTip = false

Vue.use(Rollbar, {
  accessToken: '35433eab3ec6482a83f5cc22a37b4d17',
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: true,
  source_map_enabled: true,
  environment: process.env.NODE_ENV,
  payload: {
    client: {
      javascript: {
        code_version: '1.0'
      }
    }
  }
})

new Vue({
  i18n,
  render: h => h(App)
}).$mount('#fttx-configurator')
